import '../style/SendImage.css';

import React from 'react';

export function SendImage() {

    const email = "tincisioni@gmail.com"; // your email address
    const subject = "Incisione a Tincisioni"; // email subject
    const body = "Ciao, qua allegata c'è la foto, il disegno da preparare e incidere"; // Customize the email body
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    return(
        <>
        <div className="send_image_belly">
            <div className="send_instructions_box">
                <p className='send_instructions_text'><span className='bolder_white'>Allega e invia un disegno da far incidere.</span> Invia immagini di formato <span className='bolder_white'>JPG, PNG, SVG, GIF</span> e prepareremo un disegno da incidere</p>
            </div>
            <div className="submit_box">
                <p className='send_instructions_text'>Scrivi a <span className='bolder_white'> tincisioni@gmail.com</span>, il pulsante qui sotto apre un email già compilata. Così dovrai solo allegare il file e inviarla.</p>
                <div className='submit_button_box'>
                    <button onClick={() => window.location.href = mailtoLink} className='submit_button'>Invia immagine</button>
                </div>
            </div>
        </div>
        </>
    );
    
}